"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var Box_1 = require("../Box");
var Collapsible_1 = require("../Collapsible");
var Heading_1 = require("../Heading");
var hocs_1 = require("../hocs");
var StyledAccordionPanel_1 = require("./StyledAccordionPanel");
var BasicAccordionPanel = /** @class */ (function (_super) {
    tslib_1.__extends(BasicAccordionPanel, _super);
    function BasicAccordionPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hover: undefined
        };
        _this.onMouseOver = function (event) {
            var onMouseOver = _this.props.onMouseOver;
            _this.setState({ hover: undefined }); // Can change this functionality
            if (onMouseOver) {
                onMouseOver(event);
            }
        };
        _this.onMouseOut = function (event) {
            var onMouseOut = _this.props.onMouseOut;
            _this.setState({ hover: undefined });
            if (onMouseOut) {
                onMouseOut(event);
            }
        };
        _this.onFocus = function (event) {
            var onFocus = _this.props.onFocus;
            _this.setState({ hover: undefined });
            if (onFocus) {
                onFocus(event);
            }
        };
        _this.onBlur = function (event) {
            var onBlur = _this.props.onBlur;
            _this.setState({ hover: undefined });
            if (onBlur) {
                onBlur(event);
            }
        };
        return _this;
    }
    BasicAccordionPanel.prototype.render = function () {
        var _a = this.props, children = _a.children, active = _a.active, animate = _a.animate, header = _a.header, label = _a.label, disabled = _a.disabled, theme = _a.theme, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, rest = tslib_1.__rest(_a, ["children", "active", "animate", "header", "label", "disabled", "theme", "onMouseOut", "onMouseOver", "onFocus", "onBlur", "onClick"]);
        var AccordionIcon = active ? StyledAccordionPanel_1.StyledSubtractIcon : StyledAccordionPanel_1.StyledExpandIcon;
        return (React.createElement(Box_1.Box, { flex: false },
            React.createElement(StyledAccordionPanel_1.StyledAccordionButton, { role: "tab", "aria-selected": active, "aria-expanded": active, onClick: onClick, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut, onFocus: this.onFocus, onBlur: this.onBlur, disabled: disabled }, header || (React.createElement(Box_1.Box, tslib_1.__assign({ align: "center", direction: "row", justify: "between" }, rest),
                typeof label === 'string' ? (React.createElement(Heading_1.Heading, { level: 4, color: !disabled ? 'accordionText' : 'tertiaryText', weight: 300, margin: { right: 'xsmall', vertical: 'xsmall' } }, label)) : (label),
                AccordionIcon && (React.createElement(Box_1.Box, { margin: { vertical: 'xsmall' }, flex: false },
                    React.createElement(AccordionIcon, { theme: theme, disabled: disabled })))))),
            React.createElement(Box_1.Box, { border: { side: 'bottom', color: 'border' } }, animate ? React.createElement(Collapsible_1.Collapsible, { open: active }, children) : active && children)));
    };
    BasicAccordionPanel.defaultProps = {
        animate: true,
        active: false,
        disabled: false
    };
    return BasicAccordionPanel;
}(React.Component));
var AccordionPanelWrapper = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(BasicAccordionPanel);
exports.BasicAccordionPanel = AccordionPanelWrapper;
//# sourceMappingURL=BasicAccordionPanel.js.map